import {Injectable} from "@angular/core";
import {AngularFireDatabase} from '@angular/fire/compat/database';
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {AngularFireStorage} from "@angular/fire/compat/storage";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {FirebaseConnectionVersion9} from "../firebase/FirebaseConnectionVersion9";


@Injectable()
export class FirebaseConnectionService extends FirebaseConnectionVersion9 {


    constructor( public afDb: AngularFireDatabase,
                 public afAuth: AngularFireAuth,
                 public afStorage: AngularFireStorage,
                 public afFirestore: AngularFirestore) {

    super( afDb.database, afStorage.storage, afFirestore.firestore );
  }
}

